import { ReactElement, useMemo } from 'react';
import { Stack } from '@mui/material';
import { round } from 'lodash';

import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';
import { toAbsoluteUrl } from '~utils/assetsHelpers';
import { formatPercentage } from '~utils/formatter';
import LoadingFallback from '~components/LoadingFallback';
import ReportWidgetData from '~components/ReportWidgetData';

import { useReportsVisitsSectionContext } from '../Context';

import { ReportsVisitsSectionWidgetsContainer } from './styles';

const ReportsVisitsSectionWidgets = (): ReactElement => {
  const { isCarrier } = useTypePartnerCompany();

  const {
    data: {
      summary: { data: summaryData, loading: loadingSummaryData },
    },
  } = useReportsVisitsSectionContext();

  const showWidgets = useMemo(
    () => isCarrier && Boolean(summaryData?.isOwnCompany),
    [isCarrier, summaryData],
  );

  return (
    <ReportsVisitsSectionWidgetsContainer>
      {loadingSummaryData && <LoadingFallback />}

      {!loadingSummaryData && summaryData && (
        <Stack spacing={2}>
          {showWidgets && (
            <ReportWidgetData
              description="TOTAL DE RUTAS"
              data={summaryData.totalRoutes}
              iconSrc={toAbsoluteUrl('/icons/icon_route.svg')}
              iconAlt="Route Icon"
            />
          )}

          <ReportWidgetData
            description="TOTAL DE VISITAS RUTEADAS"
            data={summaryData.totalVisits}
            iconSrc={toAbsoluteUrl('/icons/icon_box.svg')}
            iconAlt="Stop Icon"
          />

          {showWidgets && (
            <ReportWidgetData
              description="TOTAL DE VEHÍCULOS UTILIZADOS"
              data={summaryData.totalUsedVehicles}
              iconSrc={toAbsoluteUrl('/icons/icon_truck.svg')}
              iconAlt="Vehicle Icon"
            />
          )}

          <ReportWidgetData
            description="VISITAS COMPLETAS"
            data={summaryData.completedVisits}
            iconSrc={toAbsoluteUrl('/icons/icon_box_check.svg')}
            iconAlt="Stop Complete Icon"
          />

          <ReportWidgetData
            description="VISITAS DENTRO DE VENTANA HORARIA"
            data={formatPercentage(summaryData.avgItemVisitedOnTimeWindow)}
            iconSrc={toAbsoluteUrl('/icons/icon_clock.svg')}
            iconAlt="Time Icon"
          />

          {showWidgets && (
            <ReportWidgetData
              description="PROMEDIO DE CARGA POR VEHÍCULO"
              data={formatPercentage(summaryData.avgLoadByVehicle)}
              iconSrc={toAbsoluteUrl('/icons/icon_weight.svg')}
              iconAlt="Vehicle Weight Icon"
            />
          )}

          {showWidgets && (
            <ReportWidgetData
              description="EMISIÓN TOTAL DE CO2 (KG)"
              data={round(summaryData.totalCo2Emmision, 3) || 'N/A'}
              iconSrc={toAbsoluteUrl('/icons/icon_co2.svg')}
              iconAlt="CO2 Emission Icon"
            />
          )}
        </Stack>
      )}
    </ReportsVisitsSectionWidgetsContainer>
  );
};

export default ReportsVisitsSectionWidgets;
